import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { bonusTracker as orgConfig } from 'org/configs/modules.config';
import {
  BONUS_TRACKER_CLICK_HISTORY_GET_FAILURE,
  BONUS_TRACKER_CLICK_HISTORY_GET_SUCCESS,
} from '../actions/types';

const defaultConfig = {
  defaults: {
    clickHistoryConfig: {
      api: {
        options: {
          success: BONUS_TRACKER_CLICK_HISTORY_GET_SUCCESS,
          failure: BONUS_TRACKER_CLICK_HISTORY_GET_FAILURE,
        },
      },
    },
    trackerConfig: {
      indicators: {
        rewardsTextColor: '#000',
        dividerColor: '#051464',
        fontColor: '#000',
        circleColor: '#fff',
        circleBorderColor: '#68b3e7',
        circleTextColor: '#000',
        circleFontStyle: '12',
        rewardsFontSize: '20',
        rewardsLanguageFontSize: '10',
        allTiersBackgroundColor: '#051464',
        backgroundColor: [],
        borderWidth: 0,
        gaugeData: {
          value: 0,
          valueColor: '#68b3e7',
        },
        gaugeLimits: [],
        gaugeEarned: [],
        gaugeEarningColor: '',
        gaugeCurrency: 'Bonus miles',
        options: {
          baseContainerId: 'mn_indicatorCanvasContainer',
          fontBase: 500,
          defaultFontFamily: 'NeuePlak',
          defaultFontWeight: 'bold',
          events: [],
          responsive: true,
          maintainAspectRatio: false,
        },
      },
      animation: {
        circleColor: '#745ac4',
        circleBorderColor: '#fff',
        circleTextColor: 'rgba(0, 0, 0, 0.3)', // For unspent circles
        circleFontStyle: '12',
        activeBackgroundColor: '#276ef1',
        backgroundColor: ['#745ac4', '#745ac4', '#745ac4', 'transparent'],
        rewardsEarnedFontSize: '32',
        rewardsEarnedLabelFontSize: '20',
        bonusEarnedLanguage: 'miles',
        bonusEarnedLanguagePrefix: 'Bonus',
        bonusEarnedLanguageSuffix: ' earned',
        borderWidth: 0,
        gaugeData: {
          value: 0,
          earnedValue: 0,
          earnedReward: 0,
          valueCircleColor: '#267ef1', // Spent circle background
          valueTextColor: '#fff', // Spent circle text
          valueCircleBorderColor: '#fff', // Spent circle border
          earnedCenterValueColor: '#68b3e7',
        },
        gaugeLimits: [],
        options: {
          baseContainerId: 'mn_indicatorCanvasContainer',
          fontBase: 491,
          defaultFontFamily: 'NeuePlak',
          defaultFontWeight: '600',
          events: [],
          responsive: true,
          maintainAspectRatio: false,
          showEarnedMarkers: false,
          animation: {
            animateRotate: true,
            animateScale: false,
          },
        },
      },
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
